import { useEffect, useState } from "react";
import Modal from "../Modal";
import SubIdentitiesAliasesForm from "./SubIdentitiesAliasesForm";
import { setLoader } from "../../features/LoaderSlice";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import useTracker from "../../hooks/useTracker";
import useCollect from "../../hooks/useCollect";
import UnsavedModal from "../UnsavedModal";
const SubIdentitiesAliasesModal = ({
  open,
  setOpen,
  idData,
  isUnsavedAliasesOpen,
  setIsUnsavedAliasesOpen,
}) => {
  const intl = useIntl();
  const {
    identityCollect,
    handleCollectSuccessMessage,
    handleCollectErrorMessage,
  } = useCollect();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ hasSubmited: false });
  const trackerDeatils = useSelector((state) => state?.TrackerReducer);
  const { createSubIdntyAliasesTracker, removeCreateIdentityTracker } =
    useTracker();
  const handleSetOpen = (status, reload = false) => {
    if (!status) {
      setFormData({ hasSubmited: false });
      setOpen(false, reload);
    } else setOpen(status);
  };
  const handleFormData = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
  };
  const handleChange = (e) => {
    handleFormData({ [e.target.name]: e.target.value });
    createSubIdntyAliasesTracker({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  useEffect(() => {
    if (
      trackerDeatils &&
      trackerDeatils?.form_type == "subIdAlias" &&
      trackerDeatils?.modal_type == "subIdAlias"
    ) {
      setFormData({ ...trackerDeatils?.form });
      handleSetOpen(true, false);
      setIsUnsavedAliasesOpen(true);
    }
  }, []);
  const createSubidAlias = () => {
    const { digital_identity } = idData;

    const payload = {
      value: digital_identity.value,
      type: digital_identity.type,
      controller_code: digital_identity.controller_code,
      customer_scope: digital_identity.customer_scope,
      first_name: digital_identity.first_name,
      last_name: digital_identity.last_name,
      title: digital_identity.title,
      salutation: digital_identity.salutation,
      ...(digital_identity?.contact_email !== null && {
        contact_email: digital_identity?.contact_email,
      }),
      language: digital_identity.language,
      ...(formData.recordType === "Sub-Identity"
        ? { sub_identities: [] }
        : { aliases: [] }),
      collection_channel: "Truman UI",
      last_update_channel: "Truman UI",
    };
    if (formData) {
      if (formData?.recordType == "Sub-Identity") {
        const identities = [];
        identities.push({
          type: formData.type,
          value: formData.value,
        });
        payload.sub_identities = identities;
      }
      if (formData?.recordType == "Alias") {
        const aliases = [];
        aliases.push({
          type: formData.type,
          value: formData.value,
        });
        payload.aliases = aliases;
      }
    }
    dispatch(setLoader({ loading: true, label: "" }));
    identityCollect(payload, false, false, {}, false, false, false)
      .then((res) => {
        handleCollectSuccessMessage(res);
        dispatch(setLoader({ loading: false, label: "" }));
        handleSetOpen(false, true);
        removeCreateIdentityTracker();
      })
      .catch((error) => {
        handleCollectErrorMessage(error);
        dispatch(setLoader({ loading: false, label: "" }));
      });
  };
  const handleSubmit = () => {
    handleFormData({ hasSubmited: true });
    if (formData && formData?.recordType && formData?.type && formData?.value) {
      createSubidAlias();
    }
  };
  const handleCloseAndCancel = async () => {
    if (trackerDeatils?.form_type !== "subIdAlias") {
      setIsUnsavedAliasesOpen(false);
      handleSetOpen(false, true);
    } else setIsUnsavedAliasesOpen(true);
  };
  const handleCloseAndCancelUnsaved = async () => {
    setIsUnsavedAliasesOpen(false);
  };
  const handleClickOutside = async () => {
    if (trackerDeatils?.form_type !== "subIdAlias") {
      setIsUnsavedAliasesOpen(false);
    } else setIsUnsavedAliasesOpen(true);
  };
  const handleDiscardUnsaved = async () => {
    setIsUnsavedAliasesOpen(false);
    setFormData({
      type: "",
      value: "",
      recordType: "",
    });
    setTimeout(() => {
      handleSetOpen(false, true);
    }, 300);
    removeCreateIdentityTracker();
  };

  return (
    <>
      <Modal
        title={intl.formatMessage({
          id: "create.sub-id-alias.title",
          defaultMessage: "Create new Sub Identity / Alias",
        })}
        open={open}
        setOpen={handleSetOpen}
        okText={intl.formatMessage({
          id: "label.save",
          defaultMessage: "Save",
        })}
        canelText={intl.formatMessage({
          id: "label.cancel",
          defaultMessage: "Cancel",
        })}
        onSubmit={handleSubmit}
        onCancel={handleCloseAndCancel}
        handleClose={handleCloseAndCancel}
        handleClickOutside={handleClickOutside}
      >
        <SubIdentitiesAliasesForm
          handleChange={handleChange}
          handleFormData={handleFormData}
          values={formData}
        />
      </Modal>
      <UnsavedModal
        title={intl.formatMessage({
          id: "unsaved.title",
          defaultMessage: "Unsaved changes",
        })}
        subTitle={intl.formatMessage({
          id: "unsaved.subtitle",
          defaultMessage: "Are you sure you want to leave?",
        })}
        description={intl.formatMessage({
          id: "unsaved.description",
          defaultMessage:
            "You have unsaved changes. You can leave and discard the changes or cancel to continue editing.",
        })}
        open={isUnsavedAliasesOpen}
        setOpen={setIsUnsavedAliasesOpen}
        okText={intl.formatMessage({
          id: "unsaved.discardchanges",
          defaultMessage: "Discard changes",
        })}
        canelText={intl.formatMessage({
          id: "label.cancel",
          defaultMessage: "Cancel",
        })}
        handleClose={handleCloseAndCancelUnsaved}
        handleDiscard={handleDiscardUnsaved}
      />
    </>
  );
};

export default SubIdentitiesAliasesModal;